import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { LinkedOrderModificationRequestImpl } from "../model/impl/LinkedOrderModificationRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class GammaOrderRequestImplEncoder
  extends CubiqTS.LinkedOrderRequestImplEncoder
  implements BaseEncoder
{
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static __instance;

  private constructor() {
    super();
  }

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this.__instance || (this.__instance = new this());
  }
}
